import { MCStatus } from './enums'

export const mcStatusTitles = {
  [MCStatus.Activated]: 'Active',
  [MCStatus.Deactivated]: 'Deactivated',
  [MCStatus.Invited]: 'Invited',
  [MCStatus.Rejected]: 'Onboarding failed',
  pending: 'Onboarding pending',
}
